/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsCustomWarning,
    SharedserviceMelcoModelsCustomWarningFromJSON,
    SharedserviceMelcoModelsCustomWarningFromJSONTyped,
    SharedserviceMelcoModelsCustomWarningToJSON,
    SharedserviceMelcoModelsDesignElement,
    SharedserviceMelcoModelsDesignElementFromJSON,
    SharedserviceMelcoModelsDesignElementFromJSONTyped,
    SharedserviceMelcoModelsDesignElementToJSON,
    SharedserviceMelcoModelsPreview,
    SharedserviceMelcoModelsPreviewFromJSON,
    SharedserviceMelcoModelsPreviewFromJSONTyped,
    SharedserviceMelcoModelsPreviewToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsDesign
 */
export interface SharedserviceMelcoModelsDesign {
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesign
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesign
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesign
     */
    file_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesign
     */
    signature?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesign
     */
    stitches?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesign
     */
    colors?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesign
     */
    trims?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesign
     */
    color_changes?: number;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesign
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesign
     */
    height?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesign
     */
    width?: number;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesign
     */
    file_size?: number;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesign
     */
    file_type?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesign
     */
    image_resolution?: number;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesign
     */
    original_file_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesign
     */
    file_extension?: string | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsDesignElement>}
     * @memberof SharedserviceMelcoModelsDesign
     */
    element_list?: Array<SharedserviceMelcoModelsDesignElement> | null;
    /**
     * 
     * @type {string}
     * @memberof SharedserviceMelcoModelsDesign
     */
    rfm_url?: string | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsPreview>}
     * @memberof SharedserviceMelcoModelsDesign
     */
    previews?: Array<SharedserviceMelcoModelsPreview> | null;
    /**
     * 
     * @type {number}
     * @memberof SharedserviceMelcoModelsDesign
     */
    publish_state?: number;
    /**
     * 
     * @type {Date}
     * @memberof SharedserviceMelcoModelsDesign
     */
    created_date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof SharedserviceMelcoModelsDesign
     */
    publish_date?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof SharedserviceMelcoModelsDesign
     */
    updated_date?: Date | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsCustomWarning>}
     * @memberof SharedserviceMelcoModelsDesign
     */
    warning_list?: Array<SharedserviceMelcoModelsCustomWarning> | null;
}

export function SharedserviceMelcoModelsDesignFromJSON(json: any): SharedserviceMelcoModelsDesign {
    return SharedserviceMelcoModelsDesignFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsDesignFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsDesign {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'file_name': !exists(json, 'file_name') ? undefined : json['file_name'],
        'signature': !exists(json, 'signature') ? undefined : json['signature'],
        'stitches': !exists(json, 'stitches') ? undefined : json['stitches'],
        'colors': !exists(json, 'colors') ? undefined : json['colors'],
        'trims': !exists(json, 'trims') ? undefined : json['trims'],
        'color_changes': !exists(json, 'color_changes') ? undefined : json['color_changes'],
        'unit': !exists(json, 'unit') ? undefined : json['unit'],
        'height': !exists(json, 'height') ? undefined : json['height'],
        'width': !exists(json, 'width') ? undefined : json['width'],
        'file_size': !exists(json, 'file_size') ? undefined : json['file_size'],
        'file_type': !exists(json, 'file_type') ? undefined : json['file_type'],
        'image_resolution': !exists(json, 'image_resolution') ? undefined : json['image_resolution'],
        'original_file_name': !exists(json, 'original_file_name') ? undefined : json['original_file_name'],
        'file_extension': !exists(json, 'file_extension') ? undefined : json['file_extension'],
        'element_list': !exists(json, 'element_list') ? undefined : (json['element_list'] === null ? null : (json['element_list'] as Array<any>).map(SharedserviceMelcoModelsDesignElementFromJSON)),
        'rfm_url': !exists(json, 'rfm_url') ? undefined : json['rfm_url'],
        'previews': !exists(json, 'previews') ? undefined : (json['previews'] === null ? null : (json['previews'] as Array<any>).map(SharedserviceMelcoModelsPreviewFromJSON)),
        'publish_state': !exists(json, 'publish_state') ? undefined : json['publish_state'],
        'created_date': !exists(json, 'created_date') ? undefined : (new Date(json['created_date'])),
        'publish_date': !exists(json, 'publish_date') ? undefined : (json['publish_date'] === null ? null : new Date(json['publish_date'])),
        'updated_date': !exists(json, 'updated_date') ? undefined : (json['updated_date'] === null ? null : new Date(json['updated_date'])),
        'warning_list': !exists(json, 'warning_list') ? undefined : (json['warning_list'] === null ? null : (json['warning_list'] as Array<any>).map(SharedserviceMelcoModelsCustomWarningFromJSON)),
    };
}

export function SharedserviceMelcoModelsDesignToJSON(value?: SharedserviceMelcoModelsDesign | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'file_name': value.file_name,
        'signature': value.signature,
        'stitches': value.stitches,
        'colors': value.colors,
        'trims': value.trims,
        'color_changes': value.color_changes,
        'unit': value.unit,
        'height': value.height,
        'width': value.width,
        'file_size': value.file_size,
        'file_type': value.file_type,
        'image_resolution': value.image_resolution,
        'original_file_name': value.original_file_name,
        'file_extension': value.file_extension,
        'element_list': value.element_list === undefined ? undefined : (value.element_list === null ? null : (value.element_list as Array<any>).map(SharedserviceMelcoModelsDesignElementToJSON)),
        'rfm_url': value.rfm_url,
        'previews': value.previews === undefined ? undefined : (value.previews === null ? null : (value.previews as Array<any>).map(SharedserviceMelcoModelsPreviewToJSON)),
        'publish_state': value.publish_state,
        'created_date': value.created_date === undefined ? undefined : (value.created_date.toISOString()),
        'publish_date': value.publish_date === undefined ? undefined : (value.publish_date === null ? null : value.publish_date.toISOString()),
        'updated_date': value.updated_date === undefined ? undefined : (value.updated_date === null ? null : value.updated_date.toISOString()),
        'warning_list': value.warning_list === undefined ? undefined : (value.warning_list === null ? null : (value.warning_list as Array<any>).map(SharedserviceMelcoModelsCustomWarningToJSON)),
    };
}


